module.exports = __webpack_public_path__ + "files/8dab03872ff88535a7119676971e2fb4.png";